import { defineMessages } from "react-intl";

export const ROLE_MESSAGES = defineMessages({
  role: {
    id: "member-roles Role",
    defaultMessage: "Role",
  },
  thisRoleIsAbleToText: {
    id: "member-roles This role is able to",
    defaultMessage: "This role is able to",
  },
  teamMembersRoleDescriptionText: {
    id: "member-roles A team member's role determines what they can see and do.",
    defaultMessage: "A team member's role determines what they can see and do.",
  },
  warningWhenUpdatingAdminRole: {
    id: "member-roles Warning: Modifying your role",
    defaultMessage:
      "Modifying your role to a {selectedRole} will result in you not being able to edit roles in the future.",
  },
  warningWhenMemberIsLastAdmin: {
    id: "member-roles Warning: Member is last admin",
    defaultMessage: "Editing of this member's role is disabled because they are the last {role} member.",
  },
});
